import { render, staticRenderFns } from "./recept-monitoring-service.vue?vue&type=template&id=1ca844b6&scoped=true"
import script from "./recept-monitoring-service.vue?vue&type=script&lang=js"
export * from "./recept-monitoring-service.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ca844b6",
  null
  
)

export default component.exports